import { InjectionToken } from '@angular/core';

export enum AppContextEnum {
  GALLERY = 'gallery',
  ADMIN = 'admin',
  PHOTOBOOK = 'photobook',
  UNKNOWN = 'unknown',
}

export const APP_CONTEXT = new InjectionToken<AppContextEnum>('APP_CONTEXT');
